export default __webpack_public_path__ + "images/6052b5fb1c59991ab53d11dd4d46c99d-1_4K_1920x544.jpg";